'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = init;

var _request = require('@shopify/theme-cart/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var _this = this;

  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    triggers: context.getElements('.' + context.className + '_Trigger'),
    inputs: context.getElements('.js-QuantityAdjuster_Input')
  };

  els.triggers.forEach(function (el) {
    el.addEventListener('click', function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var values;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true, el);

                values = els.inputs.map(function (el) {
                  return el.value;
                });
                _context.next = 4;
                return (0, _request.cartUpdate)({
                  updates: values
                });

              case 4:

                window.location.reload();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  });

  function setLoading(isLoading, el) {
    el.classList.toggle('crt-Products_Update-loading', isLoading);
  }
}